// Extended translations for redesigned Home, Reservar, Frota (v2).
// Merged into main T dict via consumer components using useLang().t and useExtras().

export const EXTRAS = {
  en: {
    services_ext: {
      airport: { title: "Airport transfers", body: "ZRH, GVA, BSL, Milan, Munich. Meet & greet, silent cabin, flight tracking." },
      hourly: { title: "By the hour", body: "Minimum one hour. Executive travel, roadshows, multi-stop errands." },
      fullday: { title: "Full-day chauffeur", body: "8 hours from CHF 980. Multi-stop executive travel across Switzerland and neighbouring cities." },
      business: { title: "Business accounts", body: "Priority dispatch, monthly invoicing, dedicated chauffeur upon request." },
      events: { title: "Weddings & events", body: "Discreet, executive-grade transport for your most important moments. Multi-vehicle on request." },
      courier: { title: "Discreet courier", body: "Confidential hand-to-hand delivery of documents across Europe. Night hours available." },
    },
    how: {
      title: "How it works",
      steps: [
        { k: "01", t: "Reserve", d: "Choose your route, date and any extras. Prepay in seconds — funds are held securely." },
        { k: "02", t: "Confirm", d: "Instant email confirmation with your invoice. Meet-and-greet arranged if it's an airport pickup." },
        { k: "03", t: "Enjoy", d: "Your chauffeur meets you on time. A silent, immaculate cabin awaits." },
      ],
    },
    coverage: { title: "Coverage", subtitle: "One line across the Alps and the closest cross-border cities." },
    chauffeur: {
      kicker: "The chauffeur",
      heading: "Sixteen years behind the wheel. One passenger at a time.",
      body: "Swiss AlpenLine is founded and driven by a female chauffeur with 16 years on the road. All Swiss driving categories — A, A1, B, B1, B121, C and CE — with an executive protocol reserved for guests who value the cabin they don't have to explain themselves in.",
      pillars: ["A · A1 · B · B1 · B121 · C · CE", "16 years professional driving", "Executive discretion by default"],
      note: "No names. No mentions. No photographs. What happens in the cabin remains in the cabin.",
    },
    business: {
      title: "For businesses",
      heading: "One trusted partner. One invoice. One chauffeur.",
      body: "For hotels, family offices, law firms and private banks. A single point of contact, a single monthly invoice, and the same trained chauffeur — every trip. Executive discretion is the standard, not an upgrade.",
      pillars: ["Trusted partner", "Monthly invoice", "Dedicated chauffeur"],
      cta: "Open a corporate account",
    },
    testimonials: {
      title: "In the words of our first passengers",
      items: [
        { q: "Silent, punctual, spotless. Everything a global ride-hail app is not.", a: "Luzern hotel concierge" },
        { q: "Handled a last-minute cross-border → ZRH transfer at 3 am. Flawless.", a: "Private banker" },
        { q: "The courier service saved us CHF 800 on an urgent contract delivery to Milan.", a: "Zurich law office" },
      ],
    },
    swiss_law_badge: "Swiss-law compliant · CO · UCA · PIO",
    fleet_advantages: {
      title: "Why the BYD Seal U DM-i (2025) Design",
      items: [
        { k: "Whisper-quiet EV mode", d: "Full-electric range for city trips — imperceptible cabin noise." },
        { k: "Hybrid range 1'000+ km", d: "No range anxiety. Milan return without refuelling." },
        { k: "Panoramic sky roof", d: "Alpine landscapes framed by 1.5 m² of tinted glass." },
        { k: "12-way heated + ventilated seats", d: "Nappa leather. Massage function on rear seats." },
        { k: "552 L trunk (1440 L folded)", d: "Fits three large suitcases plus two cabin bags without compromise." },
        { k: "Level-2 driving assist", d: "Reduces fatigue on long transfers — your chauffeur stays fresher and safer." },
        { k: "PM2.5 cabin filter", d: "Woman-safe, allergen-safe: the interior air is filtered continuously." },
        { k: "Bi-directional charging", d: "Certified low-emission for city access zones across Europe." },
      ],
    },
  },
  pt: {
    services_ext: {
      airport: { title: "Transfers aeroporto", body: "ZRH, GVA, BSL, Milão, Munique. Meet & greet, cabine silenciosa, tracking de voo." },
      hourly: { title: "À hora", body: "Mínimo 1 hora. Executivos, roadshows, várias paragens." },
      fullday: { title: "Dia completo", body: "8h desde CHF 980. Deslocações executivas multi-paragem pela Suíça e cidades vizinhas." },
      business: { title: "Contas business", body: "Despacho prioritário, fatura mensal, chauffeur dedicado a pedido." },
      events: { title: "Casamentos & eventos", body: "Transporte executivo e discreto para os momentos mais importantes. Frota múltipla a pedido." },
      courier: { title: "Courier discreto", body: "Entrega confidencial mão-a-mão de documentos pela Europa. Serviço noturno." },
    },
    how: {
      title: "Como funciona",
      steps: [
        { k: "01", t: "Reservar", d: "Escolhe rota, data e extras. Pagamento em segundos — fundos retidos com segurança." },
        { k: "02", t: "Confirmar", d: "Email de confirmação instantâneo com fatura. Meet & greet organizado se for aeroporto." },
        { k: "03", t: "Aproveitar", d: "O teu chauffeur estará à hora certa. Uma cabine silenciosa e impecável aguarda-te." },
      ],
    },
    coverage: { title: "Cobertura", subtitle: "Uma linha entre os Alpes e as cidades transfronteiriças mais próximas." },
    chauffeur: {
      kicker: "A chauffeur",
      heading: "Dezasseis anos ao volante. Um passageiro de cada vez.",
      body: "A Swiss AlpenLine é fundada e conduzida por uma chauffeur com 16 anos de estrada. Todas as categorias suíças de condução — A, A1, B, B1, B121, C e CE — com um protocolo executivo reservado a passageiros que valorizam a cabine em que não têm de se explicar.",
      pillars: ["A · A1 · B · B1 · B121 · C · CE", "16 anos de condução profissional", "Discrição executiva por defeito"],
      note: "Sem nomes. Sem menções. Sem fotografias. O que acontece na cabine fica na cabine.",
    },
    business: {
      title: "Para empresas",
      heading: "Um parceiro de confiança. Uma fatura. Um chauffeur.",
      body: "Para hotéis, family offices, escritórios de advogados e private banks. Um único ponto de contacto, uma única fatura mensal, e o mesmo chauffeur treinado — em cada viagem. A discrição executiva é o padrão, nunca um extra.",
      pillars: ["Parceiro de confiança", "Fatura mensal", "Chauffeur dedicado"],
      cta: "Abrir conta corporate",
    },
    testimonials: {
      title: "Nas palavras dos primeiros passageiros",
      items: [
        { q: "Silencioso, pontual, impecável. Tudo o que uma app global de mobilidade não é.", a: "Concierge de hotel · Luzern" },
        { q: "Fizeram um transfer transfronteiriço → ZRH às 3h da manhã em cima da hora. Impecável.", a: "Private banker" },
        { q: "O serviço de courier poupou-nos CHF 800 numa entrega urgente para Milão.", a: "Escritório de advogados · Zurique" },
      ],
    },
    swiss_law_badge: "Conforme Direito Suíço · CO · LCD · OIP",
    fleet_advantages: {
      title: "Porquê o BYD Seal U DM-i (2025) Design",
      items: [
        { k: "Modo elétrico silencioso", d: "Alcance 100% elétrico para cidade — ruído de cabine imperceptível." },
        { k: "Autonomia híbrida 1'000+ km", d: "Sem ansiedade de autonomia. Ida-volta a Milão sem reabastecer." },
        { k: "Teto panorâmico", d: "Paisagem alpina emoldurada por 1,5 m² de vidro tintado." },
        { k: "Bancos 12-vias aquecidos + ventilados", d: "Pele Nappa. Função massagem nos traseiros." },
        { k: "Bagageira 552 L (1440 L rebatida)", d: "Três malas grandes + duas de cabine sem comprometer conforto." },
        { k: "Assist. condução nível 2", d: "Reduz fadiga em transfers longos — o chauffeur mantém-se atento e seguro." },
        { k: "Filtro cabine PM2.5", d: "Woman-safe, alergénio-safe: ar interior filtrado continuamente." },
        { k: "Certificado baixa emissão", d: "Acesso a zonas urbanas restritas em toda a Europa." },
      ],
    },
  },
  de: {
    services_ext: {
      airport: { title: "Flughafentransfers", body: "ZRH, GVA, BSL, Mailand, München. Meet & Greet, ruhige Kabine, Flug-Tracking." },
      hourly: { title: "Stundenweise", body: "Ab 1 Stunde. Führungskräfte, Roadshows, Mehrfachstopps." },
      fullday: { title: "Tageschauffeur", body: "8 h ab CHF 980. Executive-Fahrten mit mehreren Halten durch die Schweiz und angrenzende Städte." },
      business: { title: "Firmenkonten", body: "Priorität, Monatsrechnung, dedizierter Chauffeur auf Anfrage." },
      events: { title: "Hochzeiten & Events", body: "Diskreter Executive-Transport für Ihre wichtigsten Momente. Mehrere Fahrzeuge auf Anfrage." },
      courier: { title: "Diskreter Kurier", body: "Vertrauliche Dokumentenzustellung in ganz Europa. Nachtdienst verfügbar." },
    },
    how: {
      title: "So funktioniert es",
      steps: [
        { k: "01", t: "Reservieren", d: "Route, Datum, Extras wählen. Sekundenschnelle Zahlung — Gelder sicher gehalten." },
        { k: "02", t: "Bestätigen", d: "Sofortige E-Mail mit Rechnung. Meet & Greet für Flughafenabholung." },
        { k: "03", t: "Geniessen", d: "Ihr Chauffeur ist pünktlich da. Eine ruhige, makellose Kabine erwartet Sie." },
      ],
    },
    coverage: { title: "Einsatzgebiet", subtitle: "Eine Linie durch die Alpen und die grenznahen Städte." },
    chauffeur: {
      kicker: "Die Chauffeurin",
      heading: "Sechzehn Jahre am Steuer. Ein Fahrgast nach dem anderen.",
      body: "Swiss AlpenLine wird von einer Chauffeurin mit 16 Jahren Erfahrung gegründet und geführt. Alle Schweizer Führerausweiskategorien — A, A1, B, B1, B121, C und CE — mit einem Executive-Protokoll für Gäste, die die Kabine schätzen, in der sie sich nicht erklären müssen.",
      pillars: ["A · A1 · B · B1 · B121 · C · CE", "16 Jahre professionelles Fahren", "Executive-Diskretion als Standard"],
      note: "Keine Namen. Keine Erwähnungen. Keine Fotos. Was in der Kabine geschieht, bleibt in der Kabine.",
    },
    business: {
      title: "Für Unternehmen",
      heading: "Ein vertrauter Partner. Eine Rechnung. Ein Chauffeur.",
      body: "Für Hotels, Family Offices, Kanzleien und Privatbanken. Ein einziger Ansprechpartner, eine einzige Monatsrechnung und dieselbe geschulte Chauffeurin — bei jeder Fahrt. Executive-Diskretion ist der Standard, kein Aufpreis.",
      pillars: ["Vertrauter Partner", "Monatsrechnung", "Dedizierter Chauffeur"],
      cta: "Firmenkonto eröffnen",
    },
    testimonials: {
      title: "Erste Stimmen unserer Fahrgäste",
      items: [
        { q: "Ruhig, pünktlich, makellos. Alles, was eine globale Ride-Hail-App nicht ist.", a: "Hotelconcierge · Luzern" },
        { q: "Grenzüberschreitender Transfer → ZRH um 3 Uhr morgens kurzfristig — tadellos.", a: "Privatbankier" },
        { q: "Der Kurier sparte uns CHF 800 bei einer eiligen Vertragsübergabe nach Mailand.", a: "Anwaltskanzlei Zürich" },
      ],
    },
    swiss_law_badge: "Nach Schweizer Recht · OR · UWG · PBV",
    fleet_advantages: {
      title: "Warum der BYD Seal U DM-i (2025) Design",
      items: [
        { k: "Flüsterleiser E-Modus", d: "Rein elektrisch für die Stadt — unmerkliches Kabinengeräusch." },
        { k: "Hybridreichweite 1'000+ km", d: "Keine Reichweitensorgen. Retour Mailand ohne Tankstopp." },
        { k: "Panorama-Glasdach", d: "Alpen durch 1,5 m² getöntes Glas eingerahmt." },
        { k: "12-fach beheizte & belüftete Sitze", d: "Nappa-Leder. Massage im Fond." },
        { k: "Kofferraum 552 L (1440 L umgeklappt)", d: "Drei grosse Koffer plus zwei Kabinen ohne Kompromiss." },
        { k: "Fahrassistent Level 2", d: "Weniger Ermüdung — Ihr Chauffeur bleibt wach und sicher." },
        { k: "PM2.5-Kabinenfilter", d: "Woman-safe, allergikerfreundlich: kontinuierlich gefilterte Luft." },
        { k: "Zertifiziert emissionsarm", d: "Zugang zu Umweltzonen in ganz Europa." },
      ],
    },
  },
  fr: {
    services_ext: {
      airport: { title: "Transferts aéroport", body: "ZRH, GVA, BSL, Milan, Munich. Meet & greet, cabine silencieuse, suivi de vol." },
      hourly: { title: "À l'heure", body: "Minimum 1 h. Cadres, roadshows, courses multi-arrêts." },
      fullday: { title: "Journée complète", body: "8 h dès CHF 980. Déplacements executives multi-arrêts en Suisse et villes voisines." },
      business: { title: "Comptes entreprise", body: "Priorité, facturation mensuelle, chauffeur dédié sur demande." },
      events: { title: "Mariages & événements", body: "Transport executive discret pour vos moments les plus importants. Flotte multiple sur demande." },
      courier: { title: "Courrier discret", body: "Livraison confidentielle de documents partout en Europe. Service de nuit." },
    },
    how: {
      title: "Comment ça marche",
      steps: [
        { k: "01", t: "Réserver", d: "Choisissez trajet, date, options. Paiement en secondes — fonds sécurisés." },
        { k: "02", t: "Confirmer", d: "Email instantané avec facture. Meet & greet pour l'aéroport." },
        { k: "03", t: "Profiter", d: "Votre chauffeur est à l'heure. Une cabine silencieuse et impeccable vous attend." },
      ],
    },
    coverage: { title: "Zones desservies", subtitle: "Une ligne à travers les Alpes et les villes transfrontalières les plus proches." },
    chauffeur: {
      kicker: "La chauffeuse",
      heading: "Seize ans au volant. Un passager à la fois.",
      body: "Swiss AlpenLine est fondée et conduite par une chauffeuse avec 16 ans de route. Toutes les catégories de conduite suisses — A, A1, B, B1, B121, C et CE — avec un protocole exécutif réservé aux voyageurs qui apprécient une cabine où ils n'ont rien à expliquer.",
      pillars: ["A · A1 · B · B1 · B121 · C · CE", "16 ans de conduite professionnelle", "Discrétion executive par défaut"],
      note: "Pas de noms. Pas de mentions. Pas de photographies. Ce qui se passe dans la cabine reste dans la cabine.",
    },
    business: {
      title: "Pour les entreprises",
      heading: "Un partenaire de confiance. Une facture. Un chauffeur.",
      body: "Pour hôtels, family offices, cabinets d'avocats et banques privées. Un seul interlocuteur, une seule facture mensuelle, et la même chauffeuse formée — à chaque trajet. La discrétion executive est la norme, jamais un supplément.",
      pillars: ["Partenaire de confiance", "Facture mensuelle", "Chauffeur dédié"],
      cta: "Ouvrir un compte entreprise",
    },
    testimonials: {
      title: "Nos premiers passagers",
      items: [
        { q: "Silencieux, ponctuel, impeccable. Tout ce qu'une app VTC mondiale n'est pas.", a: "Concierge d'hôtel · Lucerne" },
        { q: "Transfert transfrontalier → ZRH à 3 h du matin, sans faille.", a: "Banquier privé" },
        { q: "Le courrier nous a fait économiser CHF 800 sur une livraison urgente à Milan.", a: "Cabinet d'avocats · Zurich" },
      ],
    },
    swiss_law_badge: "Conforme au droit suisse · CO · LCD · OIP",
    fleet_advantages: {
      title: "Pourquoi la BYD Seal U DM-i (2025) Design",
      items: [
        { k: "Mode électrique silencieux", d: "100% électrique en ville — bruit de cabine imperceptible." },
        { k: "Autonomie hybride 1'000+ km", d: "Aucune angoisse d'autonomie. Aller-retour Milan sans plein." },
        { k: "Toit panoramique", d: "Alpes encadrées par 1,5 m² de verre teinté." },
        { k: "Sièges 12 voies chauffants + ventilés", d: "Cuir Nappa. Massage à l'arrière." },
        { k: "Coffre 552 L (1440 L rabattu)", d: "Trois grandes valises + deux cabines sans compromis." },
        { k: "Aide à la conduite niveau 2", d: "Moins de fatigue — chauffeur plus attentif, plus sûr." },
        { k: "Filtre cabine PM2.5", d: "Woman-safe, anti-allergène : air intérieur filtré en continu." },
        { k: "Certifié faibles émissions", d: "Accès aux zones à faibles émissions partout en Europe." },
      ],
    },
  },
  it: {
    services_ext: {
      airport: { title: "Transfer aeroporti", body: "ZRH, GVA, BSL, Milano, Monaco. Meet & greet, cabina silenziosa, tracking voli." },
      hourly: { title: "Ad ore", body: "Minimo 1 h. Dirigenti, roadshow, più fermate." },
      fullday: { title: "Giornata intera", body: "8 h da CHF 980. Spostamenti executive multi-fermata in Svizzera e città vicine." },
      business: { title: "Account business", body: "Priorità, fatturazione mensile, chauffeur dedicato su richiesta." },
      events: { title: "Matrimoni & eventi", body: "Trasporto executive discreto per i vostri momenti più importanti. Flotta multipla su richiesta." },
      courier: { title: "Corriere discreto", body: "Consegna confidenziale documenti in tutta Europa. Servizio notturno." },
    },
    how: {
      title: "Come funziona",
      steps: [
        { k: "01", t: "Prenota", d: "Scegli tratta, data, extra. Pagamento in pochi secondi — fondi custoditi." },
        { k: "02", t: "Conferma", d: "Email istantanea con fattura. Meet & greet in aeroporto." },
        { k: "03", t: "Goditi", d: "Il tuo chauffeur è puntuale. Cabina silenziosa e impeccabile." },
      ],
    },
    coverage: { title: "Zone servite", subtitle: "Una linea sulle Alpi e nelle città di confine più vicine." },
    chauffeur: {
      kicker: "La chauffeur",
      heading: "Sedici anni al volante. Un passeggero alla volta.",
      body: "Swiss AlpenLine è fondata e guidata da una chauffeur con 16 anni di strada. Tutte le categorie di guida svizzere — A, A1, B, B1, B121, C e CE — con un protocollo executive riservato agli ospiti che apprezzano una cabina in cui non devono spiegarsi.",
      pillars: ["A · A1 · B · B1 · B121 · C · CE", "16 anni di guida professionale", "Discrezione executive di default"],
      note: "Nessun nome. Nessuna menzione. Nessuna fotografia. Ciò che accade in cabina resta in cabina.",
    },
    business: {
      title: "Per le aziende",
      heading: "Un partner di fiducia. Una fattura. Un chauffeur.",
      body: "Per hotel, family office, studi legali e banche private. Un unico referente, un'unica fattura mensile e la stessa chauffeur addestrata — ad ogni corsa. La discrezione executive è lo standard, mai un extra.",
      pillars: ["Partner di fiducia", "Fattura mensile", "Chauffeur dedicata"],
      cta: "Aprire un account business",
    },
    testimonials: {
      title: "Le prime voci dei passeggeri",
      items: [
        { q: "Silenzioso, puntuale, impeccabile. Tutto ciò che un'app di ride-hail globale non è.", a: "Concierge hotel · Lucerna" },
        { q: "Transfer transfrontaliero → ZRH alle 3 di notte, senza sbavature.", a: "Private banker" },
        { q: "Il corriere ci ha fatto risparmiare CHF 800 su una consegna urgente a Milano.", a: "Studio legale · Zurigo" },
      ],
    },
    swiss_law_badge: "Conforme al Diritto Svizzero · CO · LCSl · OIP",
    fleet_advantages: {
      title: "Perché la BYD Seal U DM-i (2025) Design",
      items: [
        { k: "Modalità elettrica silenziosa", d: "100% elettrico in città — rumore in cabina impercettibile." },
        { k: "Autonomia ibrida 1'000+ km", d: "Nessuna ansia d'autonomia. Milano A/R senza rifornimento." },
        { k: "Tetto panoramico", d: "Alpi incorniciate da 1,5 m² di vetro oscurato." },
        { k: "Sedili 12 vie riscaldati + ventilati", d: "Pelle Nappa. Massaggio posteriore." },
        { k: "Baule 552 L (1440 L reclinato)", d: "Tre valigie grandi + due cabine senza compromessi." },
        { k: "Assistenza guida livello 2", d: "Meno fatica — chauffeur più attento, più sicuro." },
        { k: "Filtro cabina PM2.5", d: "Woman-safe, anti-allergene: aria interna filtrata in continuo." },
        { k: "Certificato basse emissioni", d: "Accesso a zone a basse emissioni in tutta Europa." },
      ],
    },
  },
};

export const getExtras = (lang) => EXTRAS[lang] || EXTRAS.en;
